module.exports = __webpack_public_path__ + "static/media/blank.9c52c039.jpg";